export default __webpack_public_path__ + "static/severe-9784ce932ab406cac0e9f6e58f1b8170.svg";